import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { getMapDefaultConfig } from 'components/map/atoms';

// The base map for the case-level coverage maps: every built-in layer
// off, so the coverage reads alone; a user can turn layers on from the map's filter panel.
const ALL_LAYERS_OFF = {
  wellsV2: {
    checked: false,
    options: {
      surfaceHole: false,
      bottomHole: false,
      stick: false,
      survey: false,
      vertical: false,
      horizontal: false,
      horizontalPermit: false,
      horizontalDuc: false,
      horizontalProducing: false,
      horizontalShutIn: false,
      horizontalExpiredPermit: false,
      horizontalInactive: false,
      // The Create-New-Well pre-evidence stages. Required by MapUserConfig rather than
      // optional, so that a config literal forgetting them fails to compile instead of
      // silently hiding those wells.
      horizontalPrePermit: false,
      horizontalApd: false,
      horizontalProposal: false,
      horizontalPlanned: false,
      verticalPermit: false,
      verticalDuc: false,
      verticalProducing: false,
      verticalShutIn: false,
      verticalExpiredPermit: false,
      verticalInactive: false,
      verticalPrePermit: false,
      verticalApd: false,
      verticalProposal: false,
      verticalPlanned: false,
      permit: false,
      duc: false,
      producing: false,
      shutIn: false,
      expiredPermit: false,
      inactive: false,
      // Legacy bare stems — the layer never reads them, but the select-all handler writes
      // every key, so the new statuses need theirs too.
      prePermit: false,
      apd: false,
      proposal: false,
      planned: false,
    },
  },
  developmentAreas: {
    checked: false,
    options: {
      horizontalUnits: false,
      verticalUnits: false,
      fieldUnits: false,
      pricing: false,
    },
  },
  basinTier: { checked: false, options: { basin: false, tier: false } },
  titleEntityAssets: {
    checked: false,
    options: {
      surfaceInterest: false,
      workingInterest: false,
      unleased: false,
      royaltyInterest: false,
    },
  },
  scrollZoom: { checked: false },
  popups: { checked: false },
};

/**
 * The Cases list MAP STRIP's config — the evaluation-case polygons are the focus, so every
 * built-in layer starts off. Its own atom rather than the coverage map's: the two render at
 * once, and a layer turned on from one map's filter panel must not move the other.
 */
export const casesMapStripConfigAtom = atom(
  getMapDefaultConfig(ALL_LAYERS_OFF)
);

/** The Cases list coverage map's config. Not persisted. */
export const casesCoverageMapConfigAtom = atom(
  getMapDefaultConfig(ALL_LAYERS_OFF)
);

/** The case page coverage map's config. Persisted under its own key. */
export const caseCoverageMapConfigAtom = atomWithStorage(
  'insights-evaluation-case-coverage-map-config',
  getMapDefaultConfig(ALL_LAYERS_OFF)
);
